module.exports = __webpack_public_path__ + "img/img-pegasus.b0876eca.png";